import { Account } from 'shared/types/account';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';

type ThankYouHeaderProps = {
  email?: Account['email'];
};

const ThankYouHeader: React.FC<ThankYouHeaderProps> = ({ email }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className="grid justify-items-center gap-6 border-b border-neutral-400 pb-6 pt-4 md:border-b-0 lg:justify-items-start lg:p-0">
      {/* Title */}
      <Typography
        as="h3"
        asSkeleton={!email}
        className={`text-primary-black md:text-[18px] lg:text-[22px] ${email ? 'leading-tight' : 'leading-loose'}`}
      >
        {formatMessage({ id: 'thankyou.thanksForOrder', defaultMessage: 'Grazie per il tuo ordine' })}
      </Typography>

      {/* Subtitle */}
      <div className="flex flex-col items-center gap-[5px] md:flex-row">
        <Typography asSkeleton={!email} className="text-[14px] leading-loose text-primary-black md:text-[16px]">
          {formatMessage({
            id: 'feedback.emailSentTo',
            values: { email: email ?? '' },
            defaultMessage: 'Email inviata con successo a {email}.',
          })}
        </Typography>
      </div>
    </div>
  );
};

export default ThankYouHeader;
